import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getStatuses } from "../api/services";

export default function CustomStatus() {
  const [statuses, setStatuses] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getStatuses()
      .then((res) => setStatuses(res.data))
      .catch(console.error);
  }, []);

  const onChange = (e) => {
    e.preventDefault();
    if (e.target.value === "0") {
      searchParams.delete("status");
      searchParams.delete("page");
    } else {
      searchParams.set("status", e.target.value);
    }
    setSearchParams(searchParams);
  };

  return (
    <div className="d-flex align-items-center">
      <select className="form-select" id="status-select" onChange={onChange}>
        <option value={0}>Төлөв сонгох...</option>
        {statuses.map((el, i) => (
          <option value={el.id} key={i}>{el.name}</option>
        ))}
      </select>
    </div>
  );
}
